/* index.js */

"use strict";
const _ = require("lodash");

module.exports = {
    actionItems,
    ruleSeverityFormatter,
    ruleSourceFormatter,
    osFormatter,
    checkboxFormatter,
    scopeFormatter,
    nameFormatter,
    commandSetFormatter,
    commandResultFormatter,
};

function ruleSeverityFormatter(row, cell, value, columnDef, dataContext) {
    const map = dataContext.sevMap;
    const ele = createSimpleEle("rule-severity");
    ele.innerText = map[value] || "";
    return ele.outerHTML;
}

function nameFormatter(row, cell, value, columnDef, dataContext) {
    const ele = createSimpleEle("rule-name");
    ele.innerText = value || "";
    if (dataContext.dirty === true) {
        ele.classList.add("dirty-rule");
    }
    return ele.outerHTML;
}

function ruleSourceFormatter(row, cell, value, columnDef, dataContext) {
    const map = dataContext.sourceMap;
    const ele = createSimpleEle("rule-source");
    ele.innerText = map[value] || "";
    return ele.outerHTML;
}

function actionItems(row, cell, value, columnDef, dataContext) {
    const editElem = createActionElem("edit", "common.edit", dataContext.isReadOnly);
    const cloneEle = createActionElem("clone", "common.duplicate", dataContext.isReadOnly);
    const deleteEle = createActionElem("delete", "common.trash_bin", dataContext.isReadOnly);

    const wrapper = document.createElement("span");
    wrapper.classList.add("action-items");
    wrapper.append(editElem, cloneEle, deleteEle);
    return wrapper.outerHTML;
}

const ACTION_LABELS = {
    edit: "Edit Rule",
    view: "View Rule",
    clone: "Clone Rule",
    delete: "Delete Rule",
};

function createActionElem(name, icon, isReadOnly = false, type = "span") {
    const ele = document.createElement(type);
    ele.classList.add(name);
    const ico = document.createElement("base-icon-gl");
    ico.title = ACTION_LABELS[name];
    ico.dataset.icon = icon;
    if (isReadOnly && name === "edit") {
        ico.title = ACTION_LABELS.view;
        ico.dataset.icon = "configdrift.audit_policy";
    }
    ele.appendChild(ico);
    return ele;
}

function createSimpleEle(clsName, type = "span") {
    const el = document.createElement(type);
    el.classList.add(clsName);
    return el;
}

function checkboxFormatter(row, cell, value /*, columnDef, dataContext*/) {
    let checkbox = document.createElement("div");
    if (value) {
        checkbox = document.createElement("base-icon-gl");
        checkbox.dataset.icon = "common.check";
        checkbox.setDarkTheme(false);
    }
    return checkbox.outerHTML;
}

function scopeFormatter(row, cell, value) {
    if (!value) {
        return "";
    }
    return value;
}

function osFormatter(row, cell, value, columnDef) {
    if (value === "all") {
        return "All";
    }

    const osMap = columnDef.values;
    return osMap[value] || value;
}

function commandSetFormatter(row, cell, value, columnDef /*, dataContext*/) {
    let commandSetName = "";
    switch (value) {
        case "allConfig":
            commandSetName = "All Configuration";
            break;
        case "allOperational":
            commandSetName = "All Operational";
            break;
        default:
            commandSetName = "All";
    }

    const map = columnDef.nameIdMap;
    const ele = createSimpleEle("rule-command-set");
    ele.innerText = map[value] || commandSetName;
    return ele.outerHTML;
}

function commandResultFormatter(row, cell, value, columnDef, dataContext) {
    let val = "All";
    if (_.get(dataContext.commandSetResult, "type") === "restSyncItems") {
        val = _.get(
            columnDef.rsiIdNameIdMap,
            _.get(dataContext.commandSetResult, "restSyncItemId"),
            "All"
        );
    } else if (_.get(dataContext.commandSetResult, "type") === "conceptItems") {
        val = _.get(
            columnDef.conceptItemNameIdMap,
            _.get(dataContext.commandSetResult, "conceptItemId"),
            "All"
        );
    } else if (_.get(dataContext.commandSetResult, "type") === "cliCommands") {
        val = _.get(dataContext.commandSetResult, "command");
    } else if (_.get(dataContext.commandSetResult, "type") === "basicMode") {
        val = "Standard";
    }

    const ele = createSimpleEle("rule-command-result");
    ele.innerText = val || "All";
    return ele.outerHTML;
}
